import { render, staticRenderFns } from "./DmhFaqItem.vue?vue&type=template&id=52d43cac"
import script from "./DmhFaqItem.vue?vue&type=script&lang=js"
export * from "./DmhFaqItem.vue?vue&type=script&lang=js"
import style0 from "./DmhFaqItem.vue?vue&type=style&index=0&id=52d43cac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports